import Vue from 'vue';

export const useCookies = () => Vue.$cookies;
